import { Link } from "react-router-dom";

export default function Logo({ light = false }) {
  return (
    <Link to="/" data-testid="nav-logo" className="flex items-center gap-2.5 shrink-0">
      <svg width="38" height="38" viewBox="0 0 64 64" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill={light ? "#FAF7F2" : "#1E3A2B"} />
        <path
          d="M32 11c-10 8.2-15.2 15.4-15.2 22.2C16.8 41.8 23.4 49 32 49s15.2-7.2 15.2-15.8C47.2 26.4 42 19.2 32 11z"
          fill={light ? "#1E3A2B" : "#FAF7F2"}
        />
        <path
          d="M32 19v25M32 29l-7.2-5M32 36l7.2-5"
          stroke={light ? "#FAF7F2" : "#1E3A2B"}
          strokeWidth="2.4"
          strokeLinecap="round"
          fill="none"
        />
      </svg>
      <span className="leading-none">
        <span className={`font-serif text-[24px] font-semibold tracking-tight ${light ? "text-sand" : "text-forest"}`}>
          Embek
        </span>
        <span className={`block text-[9px] font-semibold uppercase tracking-[0.42em] mt-0.5 ${light ? "text-sand/70" : "text-moss"}`}>
          Group
        </span>
      </span>
    </Link>
  );
}
